<header>
        <h1>ALTID SÆSON <br><span>FOR GEVINST</span></h1>
        <img class="calender-image" src="../../../../assets/images/forside_hero/kalender/calender_oktober.svg">
        <div class="cta text-center">
                <button (click)="showPage()" class="btn btn-kl-red">SPIL MED</button>
        </div>
</header>